import { render, staticRenderFns } from "./MoveItems.vue?vue&type=template&id=2ea9fb8e&scoped=true&"
import script from "./MoveItems.vue?vue&type=script&lang=js&"
export * from "./MoveItems.vue?vue&type=script&lang=js&"
import style0 from "./MoveItems.vue?vue&type=style&index=0&id=2ea9fb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9fb8e",
  null
  
)

export default component.exports